export const PRIMARY_NAVIGATION = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/services", label: "Services" },
  { href: "/partner", label: "Partner with Us" },
  { href: "/resources", label: "Resources" },
  { href: "/contact", label: "Contact Us" },
];

export const HERO_CONTENT = {
  badgeText: "Trusted Ghana FDA partner for global innovators",
  heading: "Navigating Medical Device Registration in Ghana Just Got Easier",
  subheading:
    "Regnova is your on-the-ground partner for Ghana FDA approvals, compliant distribution, and ongoing post-market surveillance.",
  primaryCta: {
    label: "Book a consultation",
    href: "/contact",
  },
  secondaryCta: {
    label: "Explore services",
    href: "/services",
  },
  mediaTagline: "Ghana FDA Registration",
  mediaHeadline: "Local clinical expertise meeting global regulatory standards.",
  mediaPlaceholder: "Hero görseli için 1200×1600px JPG/WEBP ekleyin. Geçici placeholder.",
};

export const CTA_SECTION = {
  eyebrow: "Ready to launch?",
  heading: "Turn compliance into a competitive advantage",
  description:
    "Our Ghana-based team blends regulatory expertise, clinical insight, and logistics execution so you can focus on expanding access to life-changing medical devices.",
  primaryCta: {
    label: "Schedule a discovery call",
    href: "/contact",
  },
  secondaryCta: {
    label: "View services overview",
    href: "/services",
  },
};

export const FOOTER_LINKS = [
  { label: "Privacy policy", href: "/privacy" },
  { label: "Terms of use", href: "/terms" },
];

